import React from "react";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { Box, IconButton } from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

function Header({ columns, sortBy, setSortBy, options }) {
  const getColor = (item, order) => {
    if (
      sortBy.filter((column) => column.column === item.id)[0]?.order === order
    ) {
      return "primary.main";
    }
  };

  const handleSortButtonClick = (item) => {
    const copyState = [...sortBy];
    const oldOrder = copyState.filter((column) => column.column === item.id)[0]
      ?.order;

    const itemOldIndex = copyState.findIndex(
      (column) => column.column === item.id
    );

    if (!oldOrder) {
      copyState.push({
        column: item.id,
        order: "asc",
      });
    } else if (oldOrder === "asc") {
      copyState.push({
        column: item.id,
        order: "desc",
      });

      copyState.splice(itemOldIndex, 1);
    } else if (oldOrder === "desc") {
      copyState.splice(itemOldIndex, 1);
    }

    setSortBy(copyState);
  };

  function align(align) {
    switch (align) {
      case "right":
        return "flex-end";
      case "center":
        return "center";
      case "left":
        return "flex-start";
      default:
        return null;
    }
  }

  return (
    <TableHead
      sx={{
        width: "100%",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      <TableRow
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "spaceAround",
        }}
      >
        {options?.dragable && (
          <TableCell sx={{ width: "18px", backgroundColor: "white" }} />
        )}
        
        {columns?.map((item) => {
          if (item.view === false) {
            return null;
          } else {
            return (
              <TableCell
                sx={{
                  textAlign: item.align || options.columnAlign || "left",
                  minWidth: item.minWidth || options.columnMinWidth || "150px",
                  maxWidth: item.maxWidth || null,
                  width: "100%",
                  backgroundColor: "white",
                }}
                align={item.align || "left"}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent:
                      align(item.align) ||
                      align(options.columnAlign) ||
                      "flex-start",
                  }}
                >
                  {item.name}
                  {(options.hasOwnProperty("sortable")
                    ? options.sortable
                    : true) && (
                    <IconButton
                      size="small"
                      sx={{ display: "flex", flexDirection: "row" }}
                      onClick={() => handleSortButtonClick(item)}
                    >
                      <ArrowUpwardIcon
                        fontSize="10"
                        sx={{ color: getColor(item, "desc") }}
                      />
                      <ArrowDownwardIcon
                        fontSize="10"
                        sx={{ color: getColor(item, "asc") }}
                      />
                    </IconButton>
                  )}
                </Box>
              </TableCell>
            );
          }
        })}

        {options.actions !== false && (
          <TableCell
            sx={(theme) => ({
              minWidth: "170px",
              width: "100%",
              backgroundColor: "white",
              [theme.breakpoints.up("md")]: {
                position: "sticky",
                right: 0,
              },
              borderLeft: "dotted 1px gray",
            })}
            align={"left"}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "start",
              }}
            >
              Actions
            </Box>
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}

export default Header;
